import React from 'react';
import BannerWrapper from '@fiverr-private/gig_listings/src/GigCardListings/utils/BannerWrapper';
import { WEBSITE_MATCH_BANNER_ROW } from '../components/common/listings/constants';
import WebsiteMatchBanner from '../components/common/WebsiteMatchBanner';
import { inCategoryIdsTest, inQueryListTest } from '../experiments/websiteMatchBanner/utils';

const getWebsiteMatchBanner = ({
    inWebsiteMatchBannerTest = false,
    listingsType,
    query = '',
    categoryIds = {}
}) => {
    const shouldShowBanner = inWebsiteMatchBannerTest && (inCategoryIdsTest(categoryIds) || inQueryListTest(query));

    if (!shouldShowBanner) {
        return null;
    }

    const context = {
        listingsType,
        ...query && { query }
    };

    const websiteMatchBanner = (<WebsiteMatchBanner context={context}/>);

    return BannerWrapper(websiteMatchBanner)({ bannerRow: WEBSITE_MATCH_BANNER_ROW, className: 'website-match-banner' });
};

export default getWebsiteMatchBanner;
